<template>
	<div>
		<div class="d-flex flex-column">
			<div class="d-flex align-items-center">
				<FixedPaymentConditionPill :content="props.content" />
				<span
					class="caption text-grey-700 text-nowrap ms-2 d-flex align-items-center"
					v-if="props.prestId">
					<template v-if="props.isDisplayPlaceholders">
						<PlaceholderBox
							:height="'25px'"
							:width="'100px'" />
					</template>
					<template v-else> ID: {{ props.prestId }} </template>
				</span>
			</div>
			<span
				v-if="props.displayTitle && !isCompactDisplay"
				class="caption-strong mt-2 d-flex align-items-center">
				{{ content.fixe_title }}
			</span>

		</div>
		<div v-if="!isCompactDisplay" class="mt-2 subcaption d-flex align-items-center">
			<PackageDetailsTooltip @click="handleOpenPopup">
				<div>
					<span>{{ content.fixe_picto_i_terms_conditions_1 }}</span>
				    <TermsAndConditions />
				</div>
			</PackageDetailsTooltip>
			<div>
				{{ content.fixe_line_1 }}
			</div>
		</div>

		<DynamicPopup
			ref="popupRef"
			:overlay-color="'rgba(13, 20, 27, 0.95)'"
			:overlay-max-opacity="1">
			<PaymentConditionPopup @close="handleClosePopUp">
				<template #title>
					<div class="d-flex align-items-center gap-2">
						<FixedPaymentConditionPill
							:content="props.content"
							:height="30" />
						<div class="title-3">
							{{ content.fixe_title }}
						</div>
					</div>
				</template>
				<template #content>
					<span>{{ content.fixe_picto_i_terms_conditions_1 }}</span>
					<TermsAndConditions />
				</template>
			</PaymentConditionPopup>
		</DynamicPopup>
	</div>
</template>

<script setup lang="ts">
import { defineProps, computed, ComputedRef, ref, Ref } from "vue"
import type { ComponentPublicInstance } from "vue"

// Utils
import { isScreenMD } from "@/vue/planning/utils/breakpoints"

// Components
import FixedPaymentConditionPill from "./FixedPaymentConditionPill.vue"
import PlaceholderBox from "@/vue/planning/components/common/placeholderBox.vue"
import PackageDetailsTooltip from "./PackageDetailsTooltip.vue"
import DynamicPopup from "@/vue/common/DynamicPopup.vue"
import PaymentConditionPopup from "./PaymentConditionPopup.vue"
import TermsAndConditions from "./TermsAndConditions.vue"



// Props
interface Props {
	displayTitle: boolean
	content: { [key: string]: string }
	isPVFlex?: boolean
	prestId?: string
	isDisplayPlaceholders?: boolean
	cancellationDate?: string
	isCompactDisplay?: boolean
}

const props = defineProps<Props>()

// Refs
type DynamicPopupInstance = ComponentPublicInstance<typeof DynamicPopup>

const popupRef: Ref<DynamicPopupInstance | null> = ref(null)

// Computed
const content: ComputedRef<{ [key: string]: string }> = computed(() => {
	return props.content
})

// Methods
const handleOpenPopup = (): void => {
	// Only open the popup if the device is mobile
	if (isScreenMD.value) return

	if (popupRef.value) {
		popupRef.value.openPopup()
	}
}

const handleClosePopUp = () => {
	if (popupRef.value) {
		popupRef.value.closePopup()
	}
}
</script>
